import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { getApiBaseUrl } from '../../apiBase';

export default function ParentLinkRequests() {
    const { t } = useTranslation(['common']);
    const [requests, setRequests] = useState([]);
    const [loading, setLoading] = useState(true);
    const [busyId, setBusyId] = useState(null);

    const token = localStorage.getItem('token');
    const api = axios.create({
        baseURL: getApiBaseUrl(),
        headers: token ? { Authorization: `Bearer ${token}` } : {},
    });

    async function load() {
        setLoading(true);
        try {
            const res = await api.get('/parent/pending-requests');
            setRequests(res.data || []);
        } catch {
            setRequests([]);
        }
        setLoading(false);
    }

    useEffect(() => { load(); }, []);

    async function handleAction(linkId, action) {
        setBusyId(linkId);
        try {
            await api.post(`/parent/link-${action}/${linkId}`);
            await load();
        } catch (err) {
            alert(err.response?.data?.message || err.response?.data?.error || t('common:error'));
        }
        setBusyId(null);
    }

    if (loading || requests.length === 0) return null;

    return (
        <div style={{
            marginBottom: 20,
            padding: 16,
            background: '#fff8e1',
            borderRadius: 12,
            border: '1px solid #ffe082',
        }}>
            <h3 style={{ margin: '0 0 12px', fontSize: 16 }}>{t('parent.pendingRequests')}</h3>
            {requests.map((r) => (
                <div
                    key={r.linkId}
                    style={{
                        padding: '12px 0',
                        borderBottom: '1px solid #ffe082',
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: 8,
                        alignItems: 'center',
                        justifyContent: 'space-between',
                    }}
                >
                    <div style={{ fontSize: 14 }}>
                        <strong>{r.parentName}</strong>
                        <span style={{ color: '#666' }}> → {r.studentName}</span>
                        {r.schoolName && (
                            <div style={{ fontSize: 12, color: '#888' }}>{r.schoolName}</div>
                        )}
                    </div>
                    <div style={{ display: 'flex', gap: 8 }}>
                        <button
                            type="button"
                            disabled={busyId === r.linkId}
                            onClick={() => handleAction(r.linkId, 'approve')}
                            style={{
                                padding: '8px 14px',
                                background: '#2e7d32',
                                color: 'white',
                                border: 'none',
                                borderRadius: 8,
                                fontWeight: 600,
                                cursor: 'pointer',
                            }}
                        >
                            {t('parent.approve')}
                        </button>
                        <button
                            type="button"
                            disabled={busyId === r.linkId}
                            onClick={() => handleAction(r.linkId, 'reject')}
                            style={{
                                padding: '8px 14px',
                                background: 'white',
                                color: '#c62828',
                                border: '1px solid #ef9a9a',
                                borderRadius: 8,
                                fontWeight: 600,
                                cursor: 'pointer',
                            }}
                        >
                            {t('parent.reject')}
                        </button>
                    </div>
                </div>
            ))}
        </div>
    );
}
